import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {IPageableResponse} from '../../../../global/pagging.dto';
import {Organization, Recipient} from '../../edit-template/edit-template.dto';
import { IConnectedDocuments, LinkedContracts, LinkedDocuments } from '../organizations/organizations.dto';
import { IMetadataItemDto } from '../../settings/documentfields/metadata-item.dto';

export interface IGetRecipient extends IPageableResponse<IGetRecipientItem>{
}

export interface IGetRecipientItem{
    address?: string;
    city?: string;
    created_at?: string;
    document?: Document;
    email: string;
    firstname: string;
    id: number;
    lastname?: string;
    multi_sections?: string[];
    organization?: Organization;
    organization_id?: number;
    persnol_no?: string;
    phone_no?: string;
    profile_image?: string;
    updated_at?: string;
    user_id: number;
    workspace_id: number;
    meta_data_fields?: IMetadataItemDto[]
}

export interface IAddRecipientRequestParams{
    address?: string;
    city: string;
    email: string;
    firstname: string;
    lastname?: string;
    persnol_no?: string;
    zipcode?: string;
    phone_no?: string;
}

export interface IAddRecipientResponse{
    address?: string;
    city?: string;
    created_at?: string;
    email: string;
    firstname: string;
    id: number;
    lastname?: string;
    organization_id?: number;
    persnol_no?: string;
    phone_no?: string;
    profile_image?: string;
    updated_at?: string;
    user_id: number;
    workspace_id: number;
    zipcode?: string;
}

@Injectable({
  providedIn: 'root'
})

export class RecipientsService {

  constructor(private http: HttpClient) { }
  
  /**
   * get all the recipients
   */
  fetchRecipient(page:number | string,query:string) {
    return this.http.get<IGetRecipient | IPageableResponse<IGetRecipientItem>>(`recipients?page=${page}&q=${query}`);
  }

  /**
  * get a specific recipient by its id
  **/
  fetchRecipientById(id:number):Observable<Recipient> {
      return this.http.get<Recipient>(`recipients/${id}`);
  }

  /**
   * add recipient
   * @param formData 
   */
  addRecipient(formData: FormData | IAddRecipientRequestParams) {
    return this.http.post<Recipient>('recipients', formData);
  }


  /**
   * update recipient
   * @param formData 
   */
  updateRecipient(formData):Observable<Recipient> {
    return this.http.put<Recipient>(`recipients/${formData?.id}`, formData);
  }

  /**
   * update recipient form
   * @param formData 
   */
  updateRecipientForm(recipientId:number, formData):Observable<Recipient> {
    return this.http.post<Recipient>(`recipients/${recipientId}`, formData);
  }

  /**
   * Get linked documents with recipient
   * @param id 
   * @returns 
   */
  getLinkedDocuments(id):Observable<LinkedDocuments[]> {
    return this.http.get<LinkedDocuments[]>(`recipients/link/document/${id}`);
  }

  /**
   * Get linked contracts with recipient
   * @param id 
   * @returns 
   */
  getLinkedContracts(id):Observable<LinkedContracts[]> {
    return this.http.get<LinkedContracts[]>(`recipients/link/contractcontrol/${id}`);
  }

  /**
   * delete recipients
   * @param id 
   */
  deleteRecipient(id: number) {
    return this.http.delete(`recipients/${id}`);
  }

   /**
    * fetch linked documents
    * @param recipientId
    */
   fetchLinkedDocuments(recipientId: number) {
    return this.http.get(`recipients/${recipientId}/documents`);
  }

  /**
   * fetch linked contracts
   * @param recipientId
   */
  fetchLinkedContracts(recipientId: number) {
    return this.http.get(`recipients/${recipientId}/contacts`);
  }
  
  /**
   * search recipient by email
   * @param email 
   * @returns 
   */
  searchByEmail(email:string){
    return this.http.get(`recipients/recipient-by-email?email=${email}`);
  }

   /**
     * Make sender as recipient
     * @returns 
     */
   markSenderAsRecipient() {
    return this.http.get(`recipients/sender-as-recipient`);
  }
}
